"use strict";

define('controller/letter.template/create',['./detail'], function (LetterTemplateDetailController) {
  var LetterTemplateCreateController = LetterTemplateDetailController.extend({
    onStart: function onStart() {
      this.app.execute('achievement:unlock', 'Postman');
      return LetterTemplateDetailController.prototype.onStart.apply(this, arguments);
    }
  });
  return LetterTemplateCreateController;
});

